import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { Button, makeStyles, TextField, Box } from '@material-ui/core';

import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';

import { gridStyle, useError, Row, RowInner, ColCard} from 'utils/formStyles';
import { formatSaveData } from 'utils/formStyles';

import Dialog from 'components/RMSDialog';
import Dictionary from 'components/RMSAutoComplete/RMSDictonary';
import TextField2 from 'components/RMSTextField';
import { SSNTextMask } from 'components/RMSTextMask';
import BackDatedRecordHistory from 'components/BackDatedRecordHistory';

import { closePeopleCredentials } from 'reducers/PersonDialogsReducer';
import { getService } from 'reducers/service';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';
import { notify } from 'reducers/NotifierReducer';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PlaceLookup from 'components/RMSPlaceLookup';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { validateDateRange } from 'utils/functions';

const useStyles = makeStyles((theme) => ({
  fileInfo: {
    minHeight: 35,
    marginBottom: 16,
    '& img': {
      maxHeight: 24,
      borderRadius: 3,
      marginRight: 8,
    },
  },
  item: gridStyle(200, 800),
  txtField: {
    minWidth: 350,
  },
  closeButton: { color: theme.button.color },
}));

function PeopleCredentialsDialog(props) {
  const classes = useStyles();
  const { data } = props;
  const [Type, setType] = useState('');
  const [Number, setNumber] = useState('');
  const [State, setState] = useState(null);
  const [errors, setErrors] = useState();
  const [ssnError, setSsnError] = useState(null);
  const [curClass, setCurClass] = useState(null);
  const [IsCommercial, setIsCommercial] = useState(false);
  const [IssuedBy, setIssuedBy] = useState(null);
  const [IssuedDate, setIssuedDate] = useState(null);
  const [Expiration, setExpDate] = useState(null);
  const [Notes, setNotes] = useState('');
  const [Description, setDesc] = useState('');

  const [recordHistoryData, setRecordHistoryData] = useState({
    shouldVisible: true,
    isDisabled: true,
    createUpdateInfo: {},
  });
  const [showRecordHistory, setShowRecordHistory] = useState(false);
  const [dateErrors, setDateErrors] = useState({
    IssuedDate: '',
    ExpirationDate: '',
  });
  const [touched, setTouched] = useState({
    IssuedDate: false,
    ExpirationDate: false,
  });

  const dispatch = useDispatch();
  const { err, delErr, isValidAndChanged, formChanged } = useError(errors, setErrors);

  const userName = useSelector((state) => state.user.userData?.user.Username);
  const validateDates = (issued, exp) => {
    const result = validateDateRange({
      startDate: issued,
      endDate: exp,
      startLabel: 'Issued date',
      endLabel: 'Expiration date',
    });

    setDateErrors({
      IssuedDate: result.errors.startDate,
      ExpirationDate: result.errors.endDate,
    });

    return result.isValid;
  };

  const handleIssuedDateChange = (date) => {
    setIssuedDate(date);

    setTouched((prev) => ({
      ...prev,
      ExpirationDate: true,
    }));

    validateDates(date, Expiration);
  };

  const handleExpDateChange = (date) => {
    setExpDate(date);

    setTouched((prev) => ({
      ...prev,
      ExpirationDate: true,
    }));

    validateDates(IssuedDate, date);
  };

  useEffect(() => {
    if (data.ptsCredentialID) {
      const { ptsCredentialID, Type, ptsPersonID, Number, State, Class, IsCommercial, Issued, Expiration, Description, Notes } = data;

      setRecordHistoryData({
        shouldVisible: true,
        isDisabled: !data.Created,
        createUpdateInfo: {
          created: data.Created,
          createdBy: data.CreatedBy,
          updated: data.Updated,
          updatedBy: data.UpdatedBy,
        },
      });

      setType(Type);
      setNumber(Number);
      setState(State);
      setCurClass(Class);
      setIsCommercial(IsCommercial);
      setIssuedDate(Issued);
      setExpDate(Expiration);
      setDesc(Description);
      setNotes(Notes);
    }
  }, []);

  useEffect(() => {
    /* Check if SSN is valid or not */
    if (Type?.Code === 'SSN' && (Number || Number === '')) {
      const { firstPart, secondPart, thirdPart } = splitSSN(Number);
      const toCheckValue = parseInt(firstPart);
      const ssnNumberCheck = Number.replace(/-/g, '');

      if (ssnNumberCheck && (ssnNumberCheck.length < 9 || /[^0-9-]/.test(ssnNumberCheck)))
        setSsnError('SSN value can not be less than 9 characters.');
      // else if (toCheckValue > 799)
      //   setSsnError('First three digits of an SSN cannot be greater than 799.');
      // else if (firstPart === '000' || secondPart === '00' || thirdPart === '0000')
      //   setSsnError('None of the three parts of an SSN can be all zeros.');
      else setSsnError(null);
    } else setSsnError(null);
  }, [Number, Type]);

  const handleCloseRecordHistoryDialog = () => setShowRecordHistory(false);

  const splitSSN = (value) => {
    let firstPart = '';
    let secondPart = '';
    let thirdPart = '';

    if (value === '   -  -    ' || value === '') {
      return { firstPart: 0, secondPart, thirdPart };
    }

    for (let i of value) {
      if (i !== '-') {
        if (firstPart.length < 3) {
          firstPart += i;
        } else {
          if (secondPart.length < 2) {
            secondPart += i;
          } else {
            if (thirdPart.length < 4) {
              thirdPart += i;
            }
          }
        }
      }
    }

    return { firstPart, secondPart, thirdPart };
  };

  const close = () => {
    dispatch(closePeopleCredentials());
  };

  const save = async () => {
    setTouched({
      IssuedDate: true,
      ExpirationDate: true,
    });
    const isValid = validateDates(IssuedDate, Expiration);
    if (!isValid) return;

    const dataObj = {
      Class : curClass ?? null,
      Type: Type ? Type : null,
      State: State ? State : null,
      Number, 
      Description: Description ?? null,
      IsCommercial,
      ptsIssuedByID : IssuedBy ? IssuedBy.ptsPlaceID : null,
      Issued : IssuedDate ?? null,
      Expiration : Expiration || null,
      Notes: Notes || null, }
    const formData = formatSaveData(dataObj);
    try {
      props.showSpinner();
      const service = getService('record-person-credentials');
      if (data.ptsPersonID && data.ptsCredentialID) {
        const res = await service.patch(data.ptsCredentialID, { ...formData, UpdatedBy: userName });
        dispatch(notify('Credential updated', 'success'));
      } else {
        const res = await service.create({
          ...formData,
          ptsPersonID: data.ptsPersonID,
          CreatedBy: userName,
        });
        dispatch(notify('Credential Created', 'success'));
      }
    } catch (err) {
      props.handleError(err);
    } finally {
      close();
      props.hideSpinner();
    }
  };

  const renderActions = () => {
    return (
      <>
        {recordHistoryData?.shouldVisible && (
          <Box className="">
            <BackDatedRecordHistory
              showRecordHistory={showRecordHistory}
              setShowRecordHistory={setShowRecordHistory}
              disabled={recordHistoryData?.isDisabled}
              handleCloseRecordHistoryDialog={handleCloseRecordHistoryDialog}
              createUpdateInfo={recordHistoryData?.createUpdateInfo}></BackDatedRecordHistory>
          </Box>
        )}
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={save}
          disabled={!isValidAndChanged() || ssnError || dateErrors.IssuedDate || dateErrors.ExpirationDate}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close} className={classes.closeButton}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  const renderType = () => {
    const onChange = (ev, val) => {
      setType(val);
      formChanged();
    };
    const error = err(Type, 'Type');
    return (
      <Dictionary
        className={classes.item}
        options="codeCredentialTypes"
        onChange={onChange}
        formType={data.ptsCredentialID ? 'edit' : 'add'}
        value={Type}
        label="Type"
        error={error}
        compact
      />
    );
  };

  const renderSSNInfo = () => {
    const onChange = (e) => {
      setNumber(e.target.value);
      formChanged();
    };
    const error = err(Number, 'Credential Number');
    return (
      <TextField
        className={classes.item}
        label="Info"
        value={Number}
        onChange={onChange}
        max={100}
        error={error || ssnError}
        helperText={ssnError}
        disabled={!Type}
        compact
        variant="outlined"
        size="small"
        InputProps={{
          inputComponent: SSNTextMask,
        }}
      />
    );
  };

  const renderInfo = () => {
    const onChange = (ev, val) => {
      setNumber(val);
      formChanged();
    };
    const error = err(Number, 'Credential Number');
    return (
      <TextField2
        className={classes.item}
        label="Info"
        value={Number}
        onChange={onChange}
        max={100}
        error={error}
        disabled={!Type}
        compact
      />
    );
  };

  const renderClass = () => {
    const onChange = (ev, val) => setCurClass(val);
    return (
      <Dictionary
        options="codeCredentialClasses"
        className={classes.item}
        onChange={onChange}
        formType="edit"
        value={curClass}
        label="Class"
      />
    );
  };

  const renderDescription = () => {
    return (
      <TextField
        label="Description"
        variant="outlined"
        onChange={(e) => setDesc(e.target.value)}
        value={Description}
        size="small"
        className={classes.item}
      />
    );
  };

  const renderIsCommercial = () => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={IsCommercial}
            onChange={() => setIsCommercial(!IsCommercial)}
            color="primary"
          />
        }
        label="Commercial"
      />
    );
  };

  const renderIssuedBy = () => {
    const handleChange = (value) => setIssuedBy(value);
    const { ptsIssuedByID } = data;
    return (
      <PlaceLookup
        onChange={handleChange}
        className={classes.item}
        label="Issued By"
        ptsPlaceID={ptsIssuedByID}
      />
    );
  };

  const renderIssuedDate = () => {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          disableOpenOnEnter
          autoComplete="off"
          disableToolbar
          variant="inline"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          margin="normal"
          label="Issued Date"
          value={IssuedDate}
          onChange={handleIssuedDateChange}
          autoOk
          size="small"
          className={classes.item}
        />
      </MuiPickersUtilsProvider>
    );
  };

  const renderExpirationDate = () => {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          disableOpenOnEnter
          autoComplete="off"
          disableToolbar
          variant="inline"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          margin="normal"
          label="Expiration Date"
          value={Expiration}
          onChange={handleExpDateChange}
          autoOk
          size="small"
          className={classes.item}
          error={Boolean(touched.ExpirationDate && dateErrors.ExpirationDate)}
          helperText={touched.ExpirationDate ? dateErrors.ExpirationDate : ''}
        />
      </MuiPickersUtilsProvider>
    );
  };

  const renderNotes = () => {
    return (
      <TextField
        label="Notes"
        variant="outlined"
        onChange={(e) => setNotes(e.target.value)}
        value={Notes}
        size="small"
        multiline
        rows={5}
        className={classes.item}
      />
    );
  };
  const renderState = () => {
    const onChange = (ev, val) => {
      formChanged();
      setState(val);
    };

    return (
      <Dictionary
        options="codeStates"
        className={classes.item}
        onChange={onChange}
        formType={data.ptsCredentialID ? 'edit' : 'add'}
        value={State}
        label="State"
        compact
      />
    );
  };

  return (
    <Dialog
      toolbar
      onClose={close}
      title={data.ptsCredentialID ? 'Edit Credential' : 'Add Credential'}
      actions={renderActions()}>
      <Row>
        <ColCard minWidth={400}>
          <RowInner>
            {renderType()}
            {Type?.Code === 'SSN' ? renderSSNInfo() : renderInfo()}
          </RowInner>
          <RowInner>
            {renderState()}
            {renderClass()}
          </RowInner>
          <RowInner>
            {renderIsCommercial()}
            {renderIssuedBy()}
          </RowInner>
          <RowInner>
            {renderIssuedDate()}
            {renderExpirationDate()}
          </RowInner>
          <RowInner>{renderDescription()}</RowInner>
          <RowInner>{renderNotes()}</RowInner>
        </ColCard>
      </Row>
    </Dialog>
  );
}

export default connect(null, {
  showSpinner,
  hideSpinner,
  handleError,
  notifyDataUpdate,
})(PeopleCredentialsDialog);
